(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['app/feature-config/FeatureConfigModel', 'services/questionnaireFeatureConfigService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var questionnaireFeatureConfigService = require('./../urls').questionnaireFeatureConfigService;
    module.exports = factory(require('./../feature-config/FeatureConfigModel'), questionnaireFeatureConfigService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (FeatureConfigModel, questionnaireFeatureConfigService) {
  'use strict';

  /**
   * Model for questionnaire configuration information.
   * Uses the QuestionnaireFeatureConfigService and corresponds to a QuestionnaireFeatureConfig
   *
   * @class QuestionnaireFeatureConfigModel
   * @extends FeatureConfigModel
   * @constructor
   */
  return new (FeatureConfigModel.extend({
    urlRoot: questionnaireFeatureConfigService
  }))();
}));
